import { Region } from '../types/orderTypes';
import { BundleForRelabelling } from '../types/bundleTypes';
import { ReqEnum } from '../const/requestStatus';
import { useEffect, useState } from 'react';
import { fetchRelabelList } from '../fetch/fetchRelabelList';

export function useFetchRelabelList(
  region: Region
): [BundleForRelabelling[], ReqEnum] {
  const [fetchStatus, setFetchStatus] = useState<ReqEnum>(ReqEnum.INIT);
  const [bundlesForRelabelling, setBundlesForRelabelling] = useState<
    BundleForRelabelling[]
  >([]);

  useEffect(() => {
    setFetchStatus(ReqEnum.PENDING);
    fetchRelabelList(region).then(relabelList => {
      setBundlesForRelabelling(relabelList);
      setFetchStatus(ReqEnum.SUCCESS);
    });
  }, [region]);
  return [bundlesForRelabelling, fetchStatus];
}
